import { NmswVesselVisitList } from '@common/classes/nmsw-vessel-visit-list';
import { BreezeViewService } from '@common/services/breeze-view.service';
import { DialogService } from '@common/services/dialog.service';
import { SharedService } from '@common/services/shared.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as i0 from "@angular/core";
import * as i1 from "@common/services/breeze-view.service";
import * as i2 from "@common/services/shared.service";
import * as i3 from "@ng-bootstrap/ng-bootstrap";
import * as i4 from "@common/services/dialog.service";
import * as i5 from "@angular/common";
import * as i6 from "@angular/router";
import * as i7 from "@angular/forms";
import * as i8 from "@fortawesome/angular-fontawesome";
import * as i9 from "@progress/kendo-angular-grid";
import * as i10 from "@progress/kendo-angular-layout";
import * as i11 from "../../../common/components/action-bar/action-bar.component";
import * as i12 from "../../../common/components/app-control/app-control.component";
import * as i13 from "../../../common/components/app-form/app-form.component";
import * as i14 from "../../../common/components/content-header/content-header.component";
import * as i15 from "../../../common/components/app-grid/app-grid.component";
import * as i16 from "../../../common/components/app-control-container/app-control-container.component";
import * as i17 from "../../../common/components/flag-icon.component";
import * as i18 from "../../../common/components/check-icon.component";
import * as i19 from "../../../common/components/accordion-header.component";
import * as i20 from "../../../common/components/bookmark/bookmark.component";
import * as i21 from "@ngx-translate/core";
import * as i22 from "../../../common/pipes/codelist.pipe";
import * as i23 from "../../../common/pipes/pad.pipe";
import * as i24 from "../../../common/pipes/getVessel.pipe";
function VtsVesselVisitListComponent_ng_template_6_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\u00A0(", ctx_r8.numberOfActiveFilters - 1, ")");
  }
}
function VtsVesselVisitListComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-accordion-header", 11);
    i0.ɵɵlistener("panelChange", function VtsVesselVisitListComponent_ng_template_6_Template_app_accordion_header_panelChange_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r9 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r9.handleFilterHighlighter(true));
    });
    i0.ɵɵelementStart(1, "h5");
    i0.ɵɵelement(2, "fa-icon", 12);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵtemplate(5, VtsVesselVisitListComponent_ng_template_6_span_5_Template, 2, 1, "span", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const panel_r7 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("panel", panel_r7);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" \u00A0", i0.ɵɵpipeBind1(4, 3, "Filters"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.numberOfActiveFilters > 1);
  }
}
function VtsVesselVisitListComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-form", 14);
    i0.ɵɵlistener("submit", function VtsVesselVisitListComponent_ng_template_7_Template_app_form_submit_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r12 = i0.ɵɵnextContext();
      ctx_r12.search();
      return i0.ɵɵresetView(ctx_r12.onAutoFilterChange());
    });
    i0.ɵɵelementStart(1, "app-control-container", null, 15)(3, "div", 16)(4, "div", 17)(5, "app-control", 18);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.filter.vesselName = $event);
    });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 17)(8, "app-control", 19);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_8_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.filter.iMONumber = $event);
    });
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 17)(11, "app-control", 20);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_11_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r16 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r16.filter.statusId = $event);
    });
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "div", 17)(14, "app-control", 21);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_14_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r17 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r17.filter.statusInVts = $event);
    });
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 17)(17, "app-control", 22);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_17_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r18 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r18.filter.internalInvoiceNumber = $event);
    });
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "div", 17)(20, "app-control", 23);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_20_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r19 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r19.filter.invoiceNumber = $event);
    });
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(22, "div", 16)(23, "div", 17)(24, "app-control", 24);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_24_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r20 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r20.filter.ataFrom = $event);
    });
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(26, "div", 17)(27, "app-control", 25);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_27_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r21 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r21.filter.ataTo = $event);
    });
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(29, "div", 17)(30, "app-control", 26);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_30_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r22 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r22.filter.atdFrom = $event);
    });
    i0.ɵɵpipe(31, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(32, "div", 17)(33, "app-control", 27);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_33_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r23 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r23.filter.atdTo = $event);
    });
    i0.ɵɵpipe(34, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(35, "div", 17)(36, "app-control", 28);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_36_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r24 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r24.filter.portId = $event);
    });
    i0.ɵɵpipe(37, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(38, "div", 17)(39, "app-control", 29);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_39_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r25 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r25.filter.berthId = $event);
    });
    i0.ɵɵpipe(40, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(41, "div", 16)(42, "div", 17)(43, "app-control", 30);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_43_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r26 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r26.filter.agent = $event);
    });
    i0.ɵɵpipe(44, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(45, "div", 17)(46, "app-control", 31);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_46_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r27 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r27.filter.purposeOfCallId = $event);
    });
    i0.ɵɵpipe(47, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(48, "div", 17)(49, "app-control", 32);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_49_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r28 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r28.filter.lastPortId = $event);
    });
    i0.ɵɵpipe(50, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(51, "div", 17)(52, "app-control", 33);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_52_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r29 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r29.filter.nextPortId = $event);
    });
    i0.ɵɵpipe(53, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(54, "div", 34)(55, "app-control", 35);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_55_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r30 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r30.filter.vtsVisitNumber = $event);
    });
    i0.ɵɵpipe(56, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(57, "div", 34)(58, "app-control", 36);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_58_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r31 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r31.filter.waste = $event);
    });
    i0.ɵɵpipe(59, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(60, "div", 16)(61, "div", 34)(62, "app-control", 37);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_62_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r32 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r32.filter.countryId = $event);
    });
    i0.ɵɵpipe(63, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(64, "div", 34)(65, "app-control", 38);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_65_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r33 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r33.filter.vesselTypeId = $event);
    });
    i0.ɵɵpipe(66, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(67, "div", 34)(68, "app-control", 39);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_68_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r34 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r34.filter.bookmarkColorId = $event);
    });
    i0.ɵɵpipe(69, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(70, "div", 34)(71, "app-control", 40);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_71_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r35 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r35.filter.remarks = $event);
    });
    i0.ɵɵpipe(72, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(73, "div", 34)(74, "app-control", 41);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_74_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r36 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r36.filter.bookmarkColorId = $event);
    });
    i0.ɵɵpipe(75, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(76, "div", 34)(77, "app-control", 42);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_77_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r37 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r37.filter.bookmarkColorId = $event);
    });
    i0.ɵɵpipe(78, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(79, "div", 43)(80, "app-control", 44);
    i0.ɵɵlistener("ngModelChange", function VtsVesselVisitListComponent_ng_template_7_Template_app_control_ngModelChange_80_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r38 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r38.filter.hideExpectedVisits = $event);
    });
    i0.ɵɵpipe(81, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(82, "div", 45)(83, "div", 17)(84, "div", 46)(85, "button", 47);
    i0.ɵɵlistener("click", function VtsVesselVisitListComponent_ng_template_7_Template_button_click_85_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r39 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r39.clearFilter());
    });
    i0.ɵɵelement(86, "fa-icon", 48);
    i0.ɵɵtext(87, " \u00A0 ");
    i0.ɵɵelementStart(88, "span", 49);
    i0.ɵɵtext(89);
    i0.ɵɵpipe(90, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(91, "button", 50);
    i0.ɵɵlistener("click", function VtsVesselVisitListComponent_ng_template_7_Template_button_click_91_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r40 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r40.search());
    });
    i0.ɵɵelement(92, "fa-icon", 51);
    i0.ɵɵtext(93, " \u00A0 ");
    i0.ɵɵelementStart(94, "span", 49);
    i0.ɵɵtext(95);
    i0.ɵɵpipe(96, "translate");
    i0.ɵɵelementEnd()()()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(6, 84, "Vessel Name"))("fetch", ctx_r1.fetchAllVesselNames)("fetchOnOpen", true)("ngModel", ctx_r1.filter.vesselName)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(9, 86, "IMO Number"))("ngModel", ctx_r1.filter.iMONumber)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(12, 88, "Visit State In Billing"))("ngModel", ctx_r1.filter.statusId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(15, 90, "Visit State In VTS"))("ngModel", ctx_r1.filter.statusInVts)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(18, 92, "Internal Invoice Number"))("min", 1)("ngModel", ctx_r1.filter.internalInvoiceNumber)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(21, 94, "Invoice Number"))("ngModel", ctx_r1.filter.invoiceNumber)("entity", ctx_r1.filter);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(25, 96, "ATA From"))("time", true)("ngModel", ctx_r1.filter.ataFrom)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(28, 98, "ATA To"))("time", true)("ngModel", ctx_r1.filter.ataTo)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(31, 100, "ATD From"))("time", true)("ngModel", ctx_r1.filter.atdFrom)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(34, 102, "ATD To"))("time", true)("ngModel", ctx_r1.filter.atdTo)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(37, 104, "Port Of Call"))("ngModel", ctx_r1.filter.portId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(40, 106, "Berth"))("ngModel", ctx_r1.filter.berthId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(44, 108, "Primary Agent"))("ngModel", ctx_r1.filter.agent)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(47, 110, "Primary Purpose Of Call"))("ngModel", ctx_r1.filter.purposeOfCallId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(50, 112, "Last Port Of Call"))("ngModel", ctx_r1.filter.lastPortId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(53, 114, "Next Port Of Call"))("ngModel", ctx_r1.filter.nextPortId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(56, 116, "VTS Visit Number"))("ngModel", ctx_r1.filter.vtsVisitNumber)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(59, 118, "Waste"))("ngModel", ctx_r1.filter.waste)("entity", ctx_r1.filter);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(63, 120, "Flag"))("ngModel", ctx_r1.filter.countryId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(66, 122, "Vessel Type"))("ngModel", ctx_r1.filter.vesselTypeId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(69, 124, "Bookmark Color"))("ngModel", ctx_r1.filter.bookmarkColorId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(72, 126, "Remarks"))("ngModel", ctx_r1.filter.remarks)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(75, 128, "Cargo Type"))("ngModel", ctx_r1.filter.bookmarkColorId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(78, 130, "Commodity"))("ngModel", ctx_r1.filter.bookmarkColorId)("entity", ctx_r1.filter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(81, 132, "Hide Expected Visits"))("ngModel", ctx_r1.filter.hideExpectedVisits)("entity", ctx_r1.filter);
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(90, 134, "Clear"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(96, 136, "Search"));
  }
}
function VtsVesselVisitListComponent_ng_template_12_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function VtsVesselVisitListComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VtsVesselVisitListComponent_ng_template_12_ng_container_0_Template, 1, 0, "ng-container", 52);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
  }
}
function VtsVesselVisitListComponent_ng_template_15_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function VtsVesselVisitListComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VtsVesselVisitListComponent_ng_template_15_ng_container_0_Template, 1, 0, "ng-container", 52);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", _r5);
  }
}
const _c0 = function (a1) {
  return ["/vts-vessel-visit/view/", a1];
};
function VtsVesselVisitListComponent_ng_template_16_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r58 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-bookmark", 75);
    i0.ɵɵlistener("setColor", function VtsVesselVisitListComponent_ng_template_16_ng_template_10_Template_app_bookmark_setColor_0_listener($event) {
      i0.ɵɵrestoreView(_r58);
      const ctx_r57 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r57.setBookmarkColor($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(1, "a", 76);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r56 = ctx.$implicit;
    i0.ɵɵproperty("entityId", row_r56.id)("color", row_r56.bookmarkColorId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(4, _c0, row_r56.id));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", row_r56.visitNumber, " ");
  }
}
function VtsVesselVisitListComponent_ng_template_16_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const row_r59 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", row_r59.statusInVts, " ");
  }
}
function VtsVesselVisitListComponent_ng_template_16_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r60 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r60.statusId, "VesselVisitStatus")), " ");
  }
}
const _c1 = function (a0, a1) {
  return [a0, a1];
};
function VtsVesselVisitListComponent_ng_template_16_ng_template_19_app_flag_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "app-flag-icon", 78);
    i0.ɵɵpipe(1, "getVessel");
    i0.ɵɵelementStart(2, "a", 76);
    i0.ɵɵpipe(3, "getVessel");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "getVessel");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const row_r61 = i0.ɵɵnextContext().$implicit;
    const ctx_r62 = i0.ɵɵnextContext(2);
    let tmp_0_0;
    let tmp_3_0;
    i0.ɵɵproperty("code", (tmp_0_0 = i0.ɵɵpipeBind1(1, 5, row_r61)) == null ? null : tmp_0_0.countryId)("tooltip", true)("floating", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction2(11, _c1, ctx_r62.getVesselLink(row_r61), (tmp_3_0 = i0.ɵɵpipeBind1(3, 7, row_r61)) == null ? null : tmp_3_0.id));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 9, row_r61).name, " ");
  }
}
function VtsVesselVisitListComponent_ng_template_16_ng_template_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VtsVesselVisitListComponent_ng_template_16_ng_template_19_app_flag_icon_0_Template, 6, 14, "app-flag-icon", 77);
    i0.ɵɵpipe(1, "getVessel");
  }
  if (rf & 2) {
    const row_r61 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, row_r61));
  }
}
function VtsVesselVisitListComponent_ng_template_16_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
    i0.ɵɵpipe(3, "getVessel");
  }
  if (rf & 2) {
    const row_r64 = ctx.$implicit;
    let tmp_0_0;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, (tmp_0_0 = i0.ɵɵpipeBind1(3, 6, row_r64)) == null ? null : tmp_0_0.typeId, "VesselType")), " ");
  }
}
function VtsVesselVisitListComponent_ng_template_16_ng_template_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "getVessel");
  }
  if (rf & 2) {
    const row_r65 = ctx.$implicit;
    let tmp_0_0;
    i0.ɵɵtextInterpolate1(" ", (tmp_0_0 = i0.ɵɵpipeBind1(1, 1, row_r65)) == null ? null : tmp_0_0.iMONumber, " ");
  }
}
function VtsVesselVisitListComponent_ng_template_16_ng_template_32_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flag-icon", 79);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
  }
  if (rf & 2) {
    const row_r66 = ctx.$implicit;
    i0.ɵɵproperty("code", row_r66.portId)("floating", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind2(3, 5, row_r66.portId, "Port")), " ");
  }
}
function VtsVesselVisitListComponent_ng_template_16_ng_template_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r67 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r67.berthId, "Berth")), " ");
  }
}
function VtsVesselVisitListComponent_ng_template_16_ng_template_40_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "codelist");
  }
  if (rf & 2) {
    const row_r68 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind2(2, 3, row_r68.vtsCallPurposeId, "VtsCallPurpose")), " ");
  }
}
function VtsVesselVisitListComponent_ng_template_16_ng_template_43_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flag-icon", 79);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
  }
  if (rf & 2) {
    const row_r69 = ctx.$implicit;
    i0.ɵɵproperty("code", row_r69.lastPortId)("floating", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind2(3, 5, row_r69.lastPortId, "Port")), " ");
  }
}
function VtsVesselVisitListComponent_ng_template_16_ng_template_46_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-flag-icon", 79);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "codelist");
  }
  if (rf & 2) {
    const row_r70 = ctx.$implicit;
    i0.ɵɵproperty("code", row_r70.nextPortId)("floating", true);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind2(3, 5, row_r70.nextPortId, "Port")), " ");
  }
}
function VtsVesselVisitListComponent_ng_template_16_ng_template_49_a_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r75 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 81);
    i0.ɵɵlistener("click", function VtsVesselVisitListComponent_ng_template_16_ng_template_49_a_0_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r75);
      const row_r71 = i0.ɵɵnextContext().$implicit;
      const ctx_r73 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r73.openInvoicesModal(row_r71));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "pad");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r71 = i0.ɵɵnextContext().$implicit;
    const ctx_r72 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r72.latestInvoice(row_r71)), " ");
  }
}
function VtsVesselVisitListComponent_ng_template_16_ng_template_49_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, VtsVesselVisitListComponent_ng_template_16_ng_template_49_a_0_Template, 3, 3, "a", 80);
  }
  if (rf & 2) {
    const row_r71 = ctx.$implicit;
    const ctx_r54 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r54.latestInvoice(row_r71));
  }
}
function VtsVesselVisitListComponent_ng_template_16_ng_template_52_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-check-icon", 82);
  }
  if (rf & 2) {
    const row_r77 = ctx.$implicit;
    i0.ɵɵproperty("check", row_r77.remarks)("hideFalse", true);
  }
}
const _c2 = function () {
  return {
    enabled: true,
    checkboxOnly: true
  };
};
function VtsVesselVisitListComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r79 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-grid", 53);
    i0.ɵɵlistener("selectionChange", function VtsVesselVisitListComponent_ng_template_16_Template_app_grid_selectionChange_0_listener($event) {
      i0.ɵɵrestoreView(_r79);
      const ctx_r78 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r78.selection = $event);
    });
    i0.ɵɵelement(1, "kendo-grid-checkbox-column", 54)(2, "kendo-grid-column", 55);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelement(4, "kendo-grid-column", 56);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelement(6, "kendo-grid-column", 57);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementStart(8, "kendo-grid-column", 58);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵtemplate(10, VtsVesselVisitListComponent_ng_template_16_ng_template_10_Template, 3, 6, "ng-template", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "kendo-grid-column", 60);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵtemplate(13, VtsVesselVisitListComponent_ng_template_16_ng_template_13_Template, 1, 1, "ng-template", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "kendo-grid-column", 61);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵtemplate(16, VtsVesselVisitListComponent_ng_template_16_ng_template_16_Template, 3, 6, "ng-template", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "kendo-grid-column", 62);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵtemplate(19, VtsVesselVisitListComponent_ng_template_16_ng_template_19_Template, 2, 3, "ng-template", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "kendo-grid-column", 63);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵtemplate(22, VtsVesselVisitListComponent_ng_template_16_ng_template_22_Template, 4, 8, "ng-template", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "kendo-grid-column", 64);
    i0.ɵɵpipe(24, "translate");
    i0.ɵɵtemplate(25, VtsVesselVisitListComponent_ng_template_16_ng_template_25_Template, 2, 3, "ng-template", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(26, "kendo-grid-column", 65);
    i0.ɵɵpipe(27, "translate");
    i0.ɵɵelement(28, "kendo-grid-column", 66);
    i0.ɵɵpipe(29, "translate");
    i0.ɵɵelementStart(30, "kendo-grid-column", 67);
    i0.ɵɵpipe(31, "translate");
    i0.ɵɵtemplate(32, VtsVesselVisitListComponent_ng_template_16_ng_template_32_Template, 4, 8, "ng-template", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "kendo-grid-column", 68);
    i0.ɵɵpipe(34, "translate");
    i0.ɵɵtemplate(35, VtsVesselVisitListComponent_ng_template_16_ng_template_35_Template, 3, 6, "ng-template", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(36, "kendo-grid-column", 69);
    i0.ɵɵpipe(37, "translate");
    i0.ɵɵelementStart(38, "kendo-grid-column", 70);
    i0.ɵɵpipe(39, "translate");
    i0.ɵɵtemplate(40, VtsVesselVisitListComponent_ng_template_16_ng_template_40_Template, 3, 6, "ng-template", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(41, "kendo-grid-column", 71);
    i0.ɵɵpipe(42, "translate");
    i0.ɵɵtemplate(43, VtsVesselVisitListComponent_ng_template_16_ng_template_43_Template, 4, 8, "ng-template", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(44, "kendo-grid-column", 72);
    i0.ɵɵpipe(45, "translate");
    i0.ɵɵtemplate(46, VtsVesselVisitListComponent_ng_template_16_ng_template_46_Template, 4, 8, "ng-template", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(47, "kendo-grid-column", 73);
    i0.ɵɵpipe(48, "translate");
    i0.ɵɵtemplate(49, VtsVesselVisitListComponent_ng_template_16_ng_template_49_Template, 1, 1, "ng-template", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(50, "kendo-grid-column", 74);
    i0.ɵɵpipe(51, "translate");
    i0.ɵɵtemplate(52, VtsVesselVisitListComponent_ng_template_16_ng_template_52_Template, 1, 2, "ng-template", 59);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("data", ctx_r6.query)("selectable", i0.ɵɵpureFunction0(68, _c2))("selectBy", "id")("sortable", true)("sort", ctx_r6.gridSort)("selection", ctx_r6.selection);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("width", 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(3, 30, "Number"))("hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(5, 32, "Year"))("hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(7, 34, "ID"))("hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(9, 36, "VTS Visit Number"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(12, 38, "Visit State In VTS"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(15, 40, "Visit State In Billing"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(18, 42, "Vessel Name"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(21, 44, "Vessel Type"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(24, 46, "IMO Number"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(27, 48, "ATA"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(29, 50, "ATD"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(31, 52, "Port Of Call"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(34, 54, "Berth"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(37, 56, "Primary Agent"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(39, 58, "Primary Purpose Of Call"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(42, 60, "Last Port"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(45, 62, "Next Port"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(48, 64, "Latest Invoice"));
    i0.ɵɵproperty("sortable", false);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(51, 66, "Remarks"));
  }
}
export class VtsVesselVisitListComponent extends NmswVesselVisitList {
  constructor(breezeViewService, sharedService, modalService, dialogService) {
    super(breezeViewService, sharedService, modalService, dialogService);
    this.breezeViewService = breezeViewService;
    this.sharedService = sharedService;
    this.modalService = modalService;
    this.dialogService = dialogService;
    this.parentRoute = '/vts-vessel-visit';
    this.breadcrumb = [{
      icon: 'list',
      title: this.translateService.get('VTS Vessel Visit List')
    }];
    this.gridSort = [{
      field: 'ata',
      dir: 'desc'
    }];
  }
  getDefaultFilter(data) {
    // TO-DO: create separate queries for MSW and VTS
    return this.breezeViewService.entityManager.createEntity('GetVtsVesselVisitsQuery', {
      archived: this.activeTab === 1,
      isMswVesselVisit: false,
      hideExpectedVisits: true,
      ...data
    });
  }
  getVesselLink(row) {
    return `/code-list/${row.vessel ? 'vessel' : 'vts-vessel'}/view/`;
  }
}
VtsVesselVisitListComponent.ɵfac = function VtsVesselVisitListComponent_Factory(t) {
  return new (t || VtsVesselVisitListComponent)(i0.ɵɵdirectiveInject(i1.BreezeViewService), i0.ɵɵdirectiveInject(i2.SharedService), i0.ɵɵdirectiveInject(i3.NgbModal), i0.ɵɵdirectiveInject(i4.DialogService));
};
VtsVesselVisitListComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: VtsVesselVisitListComponent,
  selectors: [["app-vts-vessel-visit-list"]],
  features: [i0.ɵɵProvidersFeature([BreezeViewService]), i0.ɵɵInheritDefinitionFeature],
  decls: 18,
  vars: 13,
  consts: [[3, "items"], [3, "title", "breadcrumb"], [1, "filter-wrapper"], ["activeIds", "ngb-panel-0"], ["ngbPanelHeader", ""], ["ngbPanelContent", ""], [1, "mt-3", 3, "tabSelect"], ["tabStrip", ""], [3, "title", "selected"], ["kendoTabContent", ""], ["tabContent", ""], [3, "panel", "panelChange"], ["icon", "filter"], [4, "ngIf"], [3, "submit"], ["filterHighlighter", ""], [1, "row"], [1, "col"], ["type", "codelist", "property", "vesselName", 3, "label", "fetch", "fetchOnOpen", "ngModel", "entity", "ngModelChange"], ["property", "iMONumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "VesselVisitStatus", "property", "statusId", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "statusInVts", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "number", "format", "#", "property", "internalInvoiceNumber", 3, "label", "min", "ngModel", "entity", "ngModelChange"], ["property", "invoiceNumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "datetime", "property", "ataFrom", 3, "label", "time", "ngModel", "entity", "ngModelChange"], ["type", "datetime", "property", "ataTo", 3, "label", "time", "ngModel", "entity", "ngModelChange"], ["type", "datetime", "property", "atdFrom", 3, "label", "time", "ngModel", "entity", "ngModelChange"], ["type", "datetime", "property", "atdTo", 3, "label", "time", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "LocalPortFilter", "property", "portId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Berth", "property", "berthId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Agent", "property", "agent", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "VtsCallPurpose", "property", "purposeOfCallId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Port", "property", "lastPortId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Port", "property", "nextPortId", 3, "label", "ngModel", "entity", "ngModelChange"], [1, "col-2"], ["property", "vtsVisitNumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "yesno", "property", "waste", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Country", "property", "countryId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "VesselType", "property", "vesselTypeId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Color", "property", "bookmarkColorId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "yesno", "property", "remarks", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "ManifestCargoType", "property", "bookmarkColorId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Commodity", "property", "bookmarkColorId", 3, "label", "ngModel", "entity", "ngModelChange"], [1, "col-auto"], ["type", "boolean", "property", "hideExpectedVisits", 3, "label", "ngModel", "entity", "ngModelChange"], [1, "row", "mt-3"], [1, "float-right"], [1, "btn", "btn-sm", "btn-danger", "mr-2", 3, "click"], ["icon", "trash", 1, "ml-1"], [1, "btn-text"], [1, "btn", "btn-sm", "btn-primary", 3, "click"], ["icon", "search", 1, "ml-1"], [4, "ngTemplateOutlet"], ["pagerPosition", "both", "entityName", "VtsVesselVisit", "exportFileName", "VtsVesselVisitListExport", 3, "data", "selectable", "selectBy", "sortable", "sort", "selection", "selectionChange"], ["showSelectAll", "true", 3, "width"], ["field", "number", 3, "title", "hidden"], ["field", "year", 3, "title", "hidden"], ["field", "id", 3, "title", "hidden"], ["field", "visitNumber", 3, "title"], ["kendoGridCellTemplate", ""], ["field", "statusInVts", 3, "title"], ["field", "statusId", 3, "title"], ["field", "vessel.name", 3, "title"], ["field", "vessel.typeId", 3, "title"], ["field", "vessel.iMONumber", 3, "title"], ["field", "ata", "format", "g", 3, "title"], ["field", "atd", "format", "g", 3, "title"], ["field", "port.name", 3, "title"], ["field", "berth.name", 3, "title"], ["field", "agent.name", 3, "title"], ["field", "vtsCallPurposeId", 3, "title"], ["field", "lastPort.name", 3, "title"], ["field", "nextPort.name", 3, "title"], ["field", "invoices", 3, "title", "sortable"], ["field", "remarks", 3, "title"], ["entity", "VtsVesselVisit", 3, "entityId", "color", "setColor"], [1, "text-primary", "link-box", 3, "routerLink"], ["codelist", "Country", 3, "code", "tooltip", "floating", 4, "ngIf"], ["codelist", "Country", 3, "code", "tooltip", "floating"], [3, "code", "floating"], ["class", "text-primary link-box", "style", "cursor: pointer", 3, "click", 4, "ngIf"], [1, "text-primary", "link-box", 2, "cursor", "pointer", 3, "click"], [3, "check", "hideFalse"]],
  template: function VtsVesselVisitListComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelement(0, "app-action-bar", 0)(1, "app-content-header", 1);
      i0.ɵɵpipe(2, "async");
      i0.ɵɵelementStart(3, "div", 2)(4, "ngb-accordion", 3)(5, "ngb-panel");
      i0.ɵɵtemplate(6, VtsVesselVisitListComponent_ng_template_6_Template, 6, 5, "ng-template", 4);
      i0.ɵɵtemplate(7, VtsVesselVisitListComponent_ng_template_7_Template, 97, 138, "ng-template", 5);
      i0.ɵɵelementEnd()()();
      i0.ɵɵelementStart(8, "kendo-tabstrip", 6, 7);
      i0.ɵɵlistener("tabSelect", function VtsVesselVisitListComponent_Template_kendo_tabstrip_tabSelect_8_listener($event) {
        return ctx.tabSelected($event);
      });
      i0.ɵɵelementStart(10, "kendo-tabstrip-tab", 8);
      i0.ɵɵpipe(11, "translate");
      i0.ɵɵtemplate(12, VtsVesselVisitListComponent_ng_template_12_Template, 1, 1, "ng-template", 9);
      i0.ɵɵelementEnd();
      i0.ɵɵelementStart(13, "kendo-tabstrip-tab", 8);
      i0.ɵɵpipe(14, "translate");
      i0.ɵɵtemplate(15, VtsVesselVisitListComponent_ng_template_15_Template, 1, 1, "ng-template", 9);
      i0.ɵɵelementEnd()();
      i0.ɵɵtemplate(16, VtsVesselVisitListComponent_ng_template_16_Template, 53, 69, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor);
    }
    if (rf & 2) {
      i0.ɵɵproperty("items", ctx.actionBar);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 7, ctx.breadcrumb[0].title))("breadcrumb", ctx.breadcrumb);
      i0.ɵɵadvance(9);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(11, 9, "VTS Vessel Visits"))("selected", ctx.activeTab === 0);
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("title", i0.ɵɵpipeBind1(14, 11, "Archived VTS Vessel Visits"))("selected", ctx.activeTab === 1);
    }
  },
  dependencies: [i5.NgIf, i5.NgTemplateOutlet, i6.RouterLink, i7.NgControlStatus, i7.NgModel, i3.NgbAccordion, i3.NgbPanel, i3.NgbPanelContent, i3.NgbPanelHeader, i8.FaIconComponent, i9.ColumnComponent, i9.CheckboxColumnComponent, i9.CellTemplateDirective, i10.TabStripComponent, i10.TabStripTabComponent, i10.TabContentDirective, i11.ActionBarComponent, i12.AppControlComponent, i13.AppFormComponent, i14.ContentHeaderComponent, i15.AppGridComponent, i16.AppControlContainerComponent, i17.FlagIconComponent, i18.CheckIconComponent, i19.AccordionHeaderComponent, i20.BookmarkComponent, i5.AsyncPipe, i21.TranslatePipe, i22.CodelistPipe, i23.PadPipe, i24.GetVesselPipe],
  styles: ["\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZVJvb3QiOiIifQ== */"]
});